import { create } from 'lodash';
import { createSelector } from 'reselect';

const getStoreState = ({ entries = {} }) => entries;

export const getAllEntries = createSelector(
    getStoreState,
    ({ allEntries }) => allEntries
);